import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import Assignment from 'inbox/assignment'
import { selectGroupsById } from 'selectors/app/base'
import { selectRawAgentsById } from 'selectors/agents/base'
import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'

import { selectRoomFromUrl } from './rooms'

export function selectRoomAssignmentLabel(state, room) {
  const agent = selectAssignedAgentFromRoom(state, room)
  if (agent) return agent.label
  const group = selectAssignedGroupFromRoom(state, room)
  if (group) return group.name
  return null
}

export function selectAssignedAgentFromRoom(state, room) {
  const agentId = room.assignedAgentId
  if (!agentId) return null
  const agentsById = selectRawAgentsById(state)
  return agentsById[agentId] || emptyObj
}

export function selectAssignedGroupFromRoom(state, room) {
  const teamId = room.assignedTeamId
  if (!teamId) return null
  const teamsById = selectGroupsById(state)
  return teamsById[teamId] || emptyObj
}

export const selectAssignmentForRoomFromUrl = createSelector(
  selectRoomFromUrl,
  selectCurrentUser,
  selectRawAgentsById,
  selectGroupsById,
  (room, currentUser, agentsById, groupsById) => {
    const { assignedAgentId: agentId, assignedTeamId: teamId } = room
    // WTF Code quality of Assignment.build is equivalent to a dumpster fire
    return Assignment.build(
      agentsById[agentId],
      groupsById[teamId],
      currentUser,
      agentsById
    )
  }
)

export const selectAssignmentAgentNameForRoomFromUrl = createSelector(
  selectAssignmentForRoomFromUrl,
  assignment => {
    return assignment ? assignment.label : null
  }
)
